// src/components/Layout.js — Sidebar + main content wrapper
import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NavItem = ({ to, icon, label, onClick }) => {
  if (onClick) {
    return (
      <button className="nav-item" onClick={onClick}>
        <span>{icon}</span>{label}
      </button>
    );
  }
  return (
    <NavLink
      to={to}
      className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
    >
      <span>{icon}</span>{label}
    </NavLink>
  );
};

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isAdmin   = user?.role === 'admin';
  const isManager = user?.role === 'manager' || isAdmin;

  return (
    <div className="layout">
      {/* ── Sidebar ── */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          Ta-Da AI HR
          <span>Attendance & Leave System</span>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section">Main</div>
          <NavItem to="/"           icon="🏠" label="Dashboard" />
          <NavItem to="/attendance" icon="📅" label="My Attendance" />
          <NavItem to="/leave"      icon="🌴" label="My Leaves" />
          <NavItem to="/wfh"        icon="🏡" label="WFH Requests" />
          <NavItem to="/corrections"icon="✏️"  label="Corrections" />

          {isManager && (
            <>
              <div className="nav-section">Management</div>
              <NavItem to="/team"     icon="👥" label="Team View" />
              <NavItem to="/approvals"icon="✅" label="Approvals" />
              <NavItem to="/reports"  icon="📊" label="Reports" />
            </>
          )}

          {isAdmin && (
            <>
              <div className="nav-section">Admin</div>
              <NavItem to="/employees"icon="👤" label="Employees" />
              <NavItem to="/holidays" icon="🎉" label="Holidays" />
              <NavItem to="/settings" icon="⚙️" label="Settings" />
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="user-chip">
            <div className="user-avatar">
              {user?.full_name?.charAt(0)?.toUpperCase()}
            </div>
            <div className="user-info">
              <div className="user-name">{user?.full_name}</div>
              <div className="user-role">{user?.role}</div>
            </div>
            <button className="logout-btn" onClick={handleLogout} title="Logout">
              ↩
            </button>
          </div>
        </div>
      </aside>

      {/* ── Main content ── */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
